<template>
  <div
    ref="heatmap"
    class="map-container"
  />
</template>

<script>
import { gmapApi } from 'vue2-google-maps'

export default {
  name: 'HeatMap',

  props: {
    data: Array
  },

  data () {
    const latTitles = []
    const lngTitles = []

    const length = this.data.length

    Object.keys(this.data[0]).forEach((title) => {
      if (title.includes('LAT')) {
        let i = 0
        this.data.forEach((row) => {
          if (!row[title] || (typeof row[title] === 'number' && row[title] <= 90 && row[title] >= -90)) {
            i += 1
          }
        })
        if (i >= length * 0.5) {
          latTitles.push(title)
        }
      }
      if (title.includes('LONG') || title.includes('LNG')) {
        let i = 0
        this.data.forEach((row) => {
          if (!row[title] || (typeof row[title] === 'number' && row[title] <= 180 && row[title] >= -180)) {
            i += 1
          }
        })
        if (i >= length * 0.5) {
          lngTitles.push(title)
        }
      }
    })

    return {
      center: { lat: 0, lng: 0 },
      latTitles: latTitles,
      lngTitles: lngTitles
    }
  },

  computed: {
    google: gmapApi
  },

  async mounted () {
    try {
      await this.$gmapApiPromiseLazy()
      this.$mapObject = new this.google.maps.Map(
        this.$refs.heatmap,
        {
          zoomControl: true,
          mapTypeControl: false,
          scaleControl: false,
          streetViewControl: false,
          rotateControl: false,
          fullscreenControl: true,
          disableDefaultUi: false
        }
      )

      const bounds = this.createBounds(this.data)
      this.$mapObject.fitBounds(bounds)
      this.$mapObject.panToBounds(bounds)

      this.$heatmap = new this.google.maps.visualization.HeatmapLayer({
        data: this.data.map(each => (new this.google.maps.LatLng(
          each[this.latTitles[0]], each[this.lngTitles[0]]
        ))),
        map: this.$mapObject,
        opacity: 1,
        maxIntensity: 5
      })
    } catch (error) {
      this.$Message.error(`Failed to inject Google Maps API: ${error}`)
    }
  },

  methods: {
    /** Create Bounds for Markers
     * @param {Array} data original data to compute
     * @return {Array} computed bounds for markers
    */
    createBounds (data) {
      const bounds = new this.google.maps.LatLngBounds()

      data.map((each) => {
        return bounds.extend(new this.google.maps.LatLng(
          each[this.latTitles[0]], each[this.lngTitles[0]]
        ))
      })

      return bounds
    }
  }
}
</script>

<style scoped>
  .map-container {
    width:100%;
    height: 350px;
  }
</style>
